var render = function render(){var _vm=this,_c=_vm._self._c;return _c('resource-lists-empty-state',{attrs:{"title":_vm.$options.i18n.title,"description":_vm.$options.i18n.description,"svg-path":_vm.emptyProjectsIllustration,"search":_vm.search,"search-minimum-length":_vm.$options.SEARCH_MINIMUM_LENGTH}})
}
var staticRenderFns = []

export { render, staticRenderFns }